// Site bazlı yetki: panel yolu → sayfa anahtarı (9 Eki 2026). Bağımlılıksız;
// pariette.ts (X-Page başlığı) ve use-site-permissions birlikte kullanır.

/**
 * Sayfa anahtarı: yolun sonundaki değişken parçalar atılmış hali
 * (/Admin/Store/Balance/[token] → /Admin/Store/Balance). Backend
 * PageApiMap::packageKey ile aynı.
 */
export const packageKey = (path: string): string => {
  const segs = path
    .split("?")[0]
    .split("#")[0]
    .split("/")
    .filter(Boolean)
    .map((s) => (/^\[.*\]$/.test(s) || s === "*" ? "*" : s));
  while (segs.length && segs[segs.length - 1] === "*") segs.pop();
  // /Admin/Admin/... → /Admin/... (önceden çift eklenmiş anahtarlar)
  while (segs.length >= 2 && segs[0].toLowerCase() === "admin" && segs[1].toLowerCase() === "admin") segs.shift();
  return "/" + segs.join("/");
};

/**
 * Menü bağlantısının (navigation_link.url) sayfa anahtarı. Adres göreli
 * ("Store/Balance") ya da kökten ("/Admin/Store/Sales", "Admin/Store/Sales")
 * olabilir; göreliler /Admin/ altındadır. Backend PageApiMap::linkKey ile aynı.
 */
export const linkKey = (url: string | null | undefined): string | null => {
  const u = (url ?? "").trim().split("?")[0].split("#")[0].replace(/^\/+|\/+$/g, "");
  if (!u) return null;
  return packageKey("/" + (/^(admin|console)(\/|$)/i.test(u) ? u : "Admin/" + u));
};
export const normKey = (path: string) => packageKey(path).toLowerCase();

/**
 * Next app router yolunu kalıba çevirir: rota parametrelerinin değerleri
 * [ad] olur (/Admin/Store/Balance/AbCd → /Admin/Store/Balance/[token]).
 */
export const routePattern = (pathname: string, params?: Record<string, string | string[] | undefined> | null): string => {
  if (!params) return pathname;
  const byValue = new Map<string, string>();
  Object.entries(params).forEach(([k, v]) => {
    (Array.isArray(v) ? v : v ? [v] : []).forEach((x) => byValue.set(decodeURIComponent(x), k));
  });
  return (
    "/" +
    pathname
      .split("/")
      .filter(Boolean)
      .map((seg) => {
        const name = byValue.get(decodeURIComponent(seg));
        return name ? `[${name}]` : seg;
      })
      .join("/")
  );
};

/** Kapalı sayfa anahtarı bu sayfaya uyuyor mu? Önek değil; '*' ortadaki tek parça. */
export const keyMatches = (denied: string, current: string): boolean => {
  const p = normKey(denied).split("/").filter(Boolean);
  const x = current.toLowerCase().split("/").filter(Boolean);
  if (p.length !== x.length) return false;
  return p.every((seg, i) => seg === "*" || seg === x[i]);
};
